<template lang='pug'>
div
  letter-head(v-if='model')
    big Purchase Order <strong>\#{{ model.id }}</strong>
    div(v-if='model && request')
      div
        i.mat-icon date_range
        |  {{ $formatDate(model.delivery_date) }}
      div
        | # of People: <strong>{{ request.people }}</strong>
    br
    //- | For:&nbsp;
    //- strong {{ model.customer_account_name }}
    //- br
    //- | Delivery date: {{ $formatDate(model.delivery_date) }}
  page-content(v-if='model != null && request != null')
    .printable-bottom
      el-row(:gutter='$rowGutter')
        el-col(:span='12', v-if='pickupAddress')
          .subtitle Location
          .address
            strong {{ model.vendor_name }}
            br
            | {{ pickupAddress.address_line_1 }}
            template(v-if='request.suite')
              .secondary Suite: {{ request.suite }}
            template(else)
              .secondary {{ pickupAddress.address_line_2 }}
            .secondary {{ pickupAddress.city }}, {{ pickupAddress.state }} {{ pickupAddress.zip_code }}
        el-col(:span='12', v-if='model')
          .subtitle Food Ready
          .address.food-ready
            i.mat-icon.cl-primary access_time
            |  {{ $formatTime(model.food_ready_time) }}
    el-table(:data='productItems',:show-summary='true', :summary-method='itemsSummary', style='width: 100%')
      el-table-column(prop='quantity', label='QTY', width='85')
        template(slot-scope='scope')
          .printable-checkbox
          span {{ scope.row.quantity }}
      el-table-column(prop='name', label='Name')
        template(slot-scope='scope')
          .base-price
            span {{ scope.row.name }} 
            span.value ({{ $formatCents(scope.row.base_price_cents) }})
      el-table-column(prop='item_price', label='Item Price', width='105')
        template(slot-scope='scope')
          span {{ $formatCents(scope.row.base_price_cents * scope.row.quantity) }}
      el-table-column(prop='description', label='Description')
        template(slot-scope='scope')
          span
            .description {{ scope.row.product_description }}
    .printable-bottom
      el-row(:gutter='$rowGutter')
        el-col(:span='12', v-if='model')
          .subtitle Instructions
          blockquote.classic(v-if='model.purchase_order_notes') {{ model.purchase_order_notes }}
          em.cl-light(v-else, style="padding:0.5rem 0;display:inline-block;font-size:0.9rem;") None
      el-row(:gutter='$rowGutter')
        el-col(:span='24', v-if='model')
          .subtitle PLEASE NOTE:
          ul
            li Have order <strong>ready</strong> on time
            li Make sure <strong>contents &amp; quantities</strong> are correct
            li <strong>Do not charge tax</strong> &amp; Apply SimpleCater Discount
            li Provide Utensils, Plates &amp; Servingware (if requested)
</template>

<script>
  import LetterHead from './LetterHead.vue'
  import PageContent from './PageContent.vue'

  function data(){
    return {
      model: null,
      request: null,
      pickupAddress: null,
      deliveryAddress: null,
      vendor: null,
    }
  }

  function created(){
    this.getData()
  }

  function getData(){
    this.$simplecater.get(`/orders/${this.id}`).then((r)=>{
      this.model = r.data.data
      this.$simplecater.get(`/requests/${this.model.request_id}`).then((r)=>{
          this.request = r.data.data
        }).catch(()=>{
          this.$message.error("Error loading the request information")
        })
      this.$simplecater.get(`/vendors/${this.model.vendor_id}`).then((r)=>{
          this.vendor = r.data.data
        }).catch(()=>{
          this.$message.error("Error loading the vendor information")
        })
      if ( this.model.pickup_address_id ) {
        this.$simplecater.get(`/addresses/${this.model.pickup_address_id}`).then((r)=>{
            this.pickupAddress = r.data.data
          }).catch(()=>{
            this.$message.error("Error loading the address information")
          })
      }
      if ( this.model.request_address_id ) {
        this.$simplecater.get(`/addresses/${this.model.request_address_id}`).then((r)=>{
            this.deliveryAddress = r.data.data
          }).catch(()=>{
            this.$message.error("Error loading the address information")
          })
      }
    }).catch(()=>{
      this.$message.error("Error loading the data")
    })
  }

  function itemsSummary ( x ) {
    const total = this.$formatCents(_.reduce(this.model.items, ( acc, i ) => {
      console.log((i.purchase_price_cents * i.quantity));
      return acc + (i.purchase_price_cents * i.quantity)
    }, 0))
    console.log('-----------------');
    const itemsCount = _.chain(this.model.items)
      .filter(( x ) => x.type == "PRODUCT")
      .reduce(( memo, i ) => (memo + i.quantity), 0)
      .value()
    let vendorDiscount = ( this.vendor != null )? this.vendor.global_discount_percentage : ''
    return [`${itemsCount} items`,'TOTAL INCLUDING AGREED DISCOUNT (' + vendorDiscount + '%): ' + total]
  }

  const methods = { getData, itemsSummary }

  const components = { LetterHead, PageContent }

  const props = {
    id: { required: true }
  }

  const computed = {
    productItems ( ) {
      return ( this.model )? _.filter(this.model.items, ( x ) => (x.type === 'PRODUCT')) : []
    },
  }

  export default { data, components, created, methods, props, computed }
</script>

<style lang="sass">
  @import '../variables'

  .el-table__footer-wrapper
    .cell
      word-break: normal;
      word-wrap: normal;
      overflow-wrap: normal;

  .base-price
    word-break: normal;
    word-wrap: normal;
    overflow-wrap: normal;
    .value
      font-style: italic
      font-size: 0.6rem


  .printable-checkbox
    display: inline-block
    width: 3.7mm
    height: 3.7mm
    margin-right: 1.5mm
    border: 1px solid #333
    vertical-align: unset
  .printable-bottom
    .food-ready
      font-size: 1.5rem
      font-weight: bold
    .subtitle
      font-size: 1.2rem

  .description
    word-break: break-word

  ul
    li
      font-size: 0.9rem

</style>



// WEBPACK FOOTER //
// src/print/PurchaseOrderPDF.vue